import DeploymentsOverview from "./DeploymentsOverview";

export { DeploymentsOverview };
export default DeploymentsOverview;
